export default __webpack_public_path__ + "static/media/grafema_martini-contest_11.e02d2ebf.jpg";